import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import Layout from "./layout/reducers";
import Auth from "./auth/reducers";
import AppMenu from "./appMenu/reducers";
import Notification from "./notification/reducers";

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["Auth", "Notification"],
};

const rootReducer = combineReducers({
    Auth,
    AppMenu,
    Layout,
    Notification,
});

export default persistReducer(persistConfig, rootReducer);
